import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=726aeb3e&scoped=true&"
import script from "./receipt.vue?vue&type=script&lang=js&"
export * from "./receipt.vue?vue&type=script&lang=js&"
import style0 from "./receipt.vue?vue&type=style&index=0&id=726aeb3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726aeb3e",
  null
  
)

export default component.exports